module.exports = __webpack_public_path__ + "static/media/StrengtheningOurSocialSupportNetwork.dac41059.png";